module.exports = __webpack_public_path__ + "static/media/add_blue.3aa6171d.svg";